<template>
  <div :style="style" class="audio-video-container" v-if="component.data.data.src==LOCAL">
    <div v-if="component.data&&component.data.data.type==MEDIA_TYPE_AUDIO" style="width:100%">
        <div class="info-panel">
            <div class="file-title">{{$common.removeExtension(component.data.data.value.file)}}</div>
            <div class="file-size">{{$common.fileSize(component.data.data.value.file)}}</div>
        </div>
        <audio preload="metadata" :id="id" :src='media_url' controls="controls" style="width:100%">$t('message.audio_not_support')</audio>
    </div>
    <div v-if="component.data&&component.data.data.type==MEDIA_TYPE_VIDEO">
        <video preload="metadata" :id="id" :poster='cover' :src='media_url' controls="controls" style="width:100%">$t('message.video_not_support')</video> 
    </div>       
  </div>

  <div :style="style" class="audio-video-container" v-if="component.data.data.src==EXTERNAL">
    <div v-if="component.data&&component.data.data.type==MEDIA_TYPE_AUDIO" style="width:100%">
        <div class="info-panel">
            <div class="file-title">$t('message.unknown')</div>
            <div class="file-size">$t('message.unknown')</div>
        </div>
        <audio preload="metadata" :id="id"  :src='component.data.data.value' controls="controls" style="width:100%">$t('message.audio_not_support')</audio>
    </div>
    <div v-if="component.data&&component.data.data.type==MEDIA_TYPE_VIDEO">
        <video preload="metadata" :id="id"  :src='component.data.data.value' controls="controls" style="width:100%">$t('message.video_not_support')</video> 
    </div>       
  </div>

  <div :style="style" class="audio-video-container" v-if="component.data.data.src==EMBED" :id="id">
      <CktextComponent :rawHtml="embedhtml">    
      </CktextComponent>
  </div>

</template>

<script>

import axios from 'axios'

export default {
  name: 'AudioVideo',
  data(){
    return {
      style:'',
      MEDIA_TYPE_VIDEO:5,
      MEDIA_TYPE_AUDIO:6,
      EMBED:1,
      EXTERNAL:2,
      LOCAL:3,
      cover:'',
      media_url:'',
      pos:0,
      id:'',
      key:'',
      embedhtml:''
    }
  },
  props: {
    component: null,
    srid:null
  },
  methods: { 
    play(){

      const playUrl=this.$common.HOST+"/traffic/play.html?key="+this.key;

      axios
      .post(playUrl,{})
      .then()
      .catch(() => {
 
      })

    },
    eventListener(){

      const player = document.getElementById(this.id);

      const _this=this;

      if(player){

        player.addEventListener('play', () => {

          if(_this.pos==0)
          {

            _this.$common.confirmPlay(player.src);

            _this.pos=1;

          }
          

        }); 
        
        player.addEventListener('ended', () => {

          _this.$common.playMedia(player, _this.component.data.data.value.file.filename, '');

          _this.pos=0;

        }); 

        player.addEventListener('error', () => {

          if(player.src.endsWith('status-1'))
            _this.$toast.add({severity:'error', summary: '88 二维码', detail:'无效的音视频文件', life: 6000});

          if(player.src.endsWith('status-2'))
            _this.$toast.add({severity:'error', summary: '88 二维码', detail:'已经超过试用播放次数，请联系二维码所有人或 88 二维码客服', life: 6000});

          if(player.src.endsWith('status-3'))
            _this.$toast.add({severity:'error', summary: '88 二维码', detail:'音视频播放流量余额不足，请联系二维码所有人或 88 二维码客服', life: 6000});


        }); 

      }
      else
        setTimeout(()=>{_this.eventListener()},1000);

    },
    adjustScreenSize(html){

      const player = document.getElementById(this.id);

      if(player){

        const playerwidth=player.offsetWidth;

        const regVW=/width="([^"]+)"/;

        const videowidthmatches=regVW.exec(html);

        const regVH=/height="([^"]+)"/;

        const videoheightmatches=regVH.exec(html);

        if(videowidthmatches&&videowidthmatches.length>=2&&videoheightmatches&&videoheightmatches.length>=2){

          const playerheight=playerwidth*(videoheightmatches[1]/videowidthmatches[1]);

          html=html.replace(/width="([^"]+)"/,'width="'+playerwidth+'"');

          html=html.replace(/height="([^"]+)"/,'height="'+playerheight+'"');

        }

        this.embedhtml=html;

      }
      else
        setTimeout(()=>{this.adjustScreenSize(html)},1000);

    }   
  },
  created(){
    
    this.style=this.$common.generateStyle(this.component.data.style);

    this.id=this.$common.generateKey();

  },
  mounted(){

    if(this.component.data.data.src==this.LOCAL){

      this.cover=JSON.parse(this.component.data.data.value.file.misc).cover;

      const player = document.getElementById(this.id);

      this.$common.playMedia(player, this.component.data.data.value.file.filename, '');

      this.eventListener();

    }

    if(this.component.data.data.src==this.EMBED){

      this.adjustScreenSize(this.component.data.data.value);

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.audio-video-container{
    box-shadow: 0 0.256rem 0.59733rem rgb(0 0 0 / 7%);
    background-color: #fff;
    border-radius: 0.34133rem;
}

.video-container{
    text-align: center;
}

.info-panel{
    display: flex;
    justify-content: space-between;
    padding:1rem 0.5rem;
}

.file-title{
    font-size: 0.59733rem;
    color: #353535;
    word-break: break-all;
    line-height: 0.85333rem;
}

.file-size{
    font-size: 0.512rem;
    line-height: 0.85333rem;
    color: #999;
    word-break: normal;
}
</style>
